import React from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
import { Col, Row } from './Grid/index.js';
const SectionStyled = styled(Row) `
  border-top: 1px solid ${THEME.COLOR_GREY};
  margin-bottom: ${THEME.GRID_SPACING}px;
`;
const SectionInfo = styled.div `
  padding: ${THEME.GRID_SPACING}px ${THEME.GRID_SPACING}px
    ${THEME.GRID_SPACING}px 0px;

  & > h3 {
    margin-top: 0em;
    margin-bottom: 0.5em;
    font-size: 0.9em;
  }

  & > p {
    font-size: 0.8em;
    margin-top: 0em;
  }
`;
export const SectionContentPanel = styled.div `
  border-radius: 3px;
  box-shadow: 0 20px 70px -30px rgba(0, 0, 0, 0.15);
  opacity: ${(props) => props.active || typeof props.active === 'undefined' ? 1 : 0.6};
  background-color: ${(props) => props.active || typeof props.active === 'undefined'
    ? 'transparent'
    : THEME.SURFACE_INSET};
  padding: ${THEME.GRID_SPACING}px ${THEME.GRID_SPACING}px 0
    ${THEME.GRID_SPACING}px;
  margin-bottom: 10px;
  border: 1px solid ${THEME.BORDER_STRONG};

  & > h4 {
    margin-top: 0;
  }
`;
const SectionContent = styled.div `
  padding: ${THEME.GRID_SPACING}px 0 ${THEME.GRID_SPACING}px
    ${THEME.GRID_SPACING}px;
`;
export const Section = (props) => {
    return (React.createElement(SectionStyled, null,
        React.createElement(Col, { width: "5" },
            React.createElement(SectionInfo, null,
                React.createElement("h3", null, props.header),
                React.createElement("p", null, props.description))),
        React.createElement(Col, { width: "7" },
            React.createElement(SectionContent, null, props.children))));
};
//# sourceMappingURL=PanelSection.js.map